"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMod10ControlDigit = calculateMod10ControlDigit;
function calculateMod10ControlDigit(input) {
    let sum = 0;
    let shouldDouble = true;
    for (let i = input.length - 1; i >= 0; i--) {
        let digit = parseInt(input.charAt(i), 10);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return (10 - (sum % 10)) % 10;
}
//# sourceMappingURL=index.js.map